import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';
import {TabStatusEnum} from '../../../../../../../shared/tabs/tab-status.model';
import {EvaluationCriteriaTabVM} from '../step-6-1-evaluation-criteria-comparison.types';
import {EvaluationCriteriaSummaryChartComponent} from './evaluation-criteria-summary-chart/evaluation-criteria-summary-chart.component';
import {
  IMPORTANCE_SCORE_TYPE_CONFIG,
  SCORED_IMPORTANCE_SCORE_TYPES,
} from './evaluation-criteria-summary-chart/evaluation-criteria-summary-chart.types';
import {
  SummaryChartVM,
  SummaryLegendItem,
} from './step-6-1-evaluation-criteria-comparison-summary.types';

@Component({
  selector: 'app-step-6-1-evaluation-criteria-comparison-summary',
  imports: [EvaluationCriteriaSummaryChartComponent, TranslateDirectusPipe, TranslocoPipe],
  templateUrl: './step-6-1-evaluation-criteria-comparison-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Step61EvaluationCriteriaComparisonSummaryComponent {
  readonly criteria = input.required<EvaluationCriteriaTabVM[]>();

  readonly charts = computed<SummaryChartVM[]>(() => {
    return this.criteria()
      .filter((criteria) => criteria.status === TabStatusEnum.COMPLETED)
      .map((criteria) => ({
        ecNumber: criteria.ecNumber,
        translations: criteria.translations,
        importanceScores: this.collectImportanceScores(criteria),
      }));
  });

  readonly hasCharts = computed<boolean>(() => {
    return this.charts().length > 0;
  });

  readonly legend = computed<SummaryLegendItem[]>(() => {
    return SCORED_IMPORTANCE_SCORE_TYPES.map((type) => ({
      translationKey: IMPORTANCE_SCORE_TYPE_CONFIG[type].translationKey,
      backgroundColor: IMPORTANCE_SCORE_TYPE_CONFIG[type].color,
      type: type,
    }));
  });

  private collectImportanceScores(
    criteria: EvaluationCriteriaTabVM,
  ): EvaluationSubCriteriaImportanceScore[] {
    return criteria.subCriteria.flatMap((subCriteria) =>
      subCriteria.attributes
        .map((attribute) => attribute.score)
        .filter((score): score is EvaluationSubCriteriaImportanceScore => score !== undefined),
    );
  }
}
